import { AddCartNonPricedProductFormValues } from "./types";
import * as yup from "yup";
import {
  testFloat,
  testFloatAndMoney,
  testPositiveFloat,
} from "../../../products/utils";

export const defaultFormValues: AddCartNonPricedProductFormValues = {
  productId: "",
  quantity: "1",
  name: "",
  price: "0",
};

export const schema = yup.object().shape({
  productId: yup.string().required(),
  name: yup.string().optional(),
  quantity: yup
    .string()
    .test("valid-quantity", "Invalid Value", testFloat as any)
    .required("Quantity is required"),
  price: yup
    .string()
    .test("valid-money", "Invalid Value", testFloatAndMoney as any)
    .test("positive", "Quantity must be positive", testPositiveFloat as any)
    .test(
      "not-zero",
      "Price must be greater than zero",
      (value) => parseFloat(value ?? "0") > 0
    )
    .required("Retail Price is required"),
});
